module.exports = "<simple-notifications\r\n  [ngClass]=\"{closeIcon: options.hasCloseIcon}\"\r\n  [options]=\"options\">\r\n</simple-notifications>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/message/message-center/message-center.component.html
// module id = 809
// module chunks = 0